// import loadbtn from '@@/loadBtn';
import loadbtn from "../components/loadBtn.vue";
export default {
  install: function(Vue) {
    Vue.component("load-button", loadbtn);
  },
};
